import { validateOptions } from '../utils/generalUtils';
import { safeEval } from '../utils/safeEval';
import { ctrlRegistry } from './CustomCtrl'

const EMPTY_ARRAY = [];

export const doRegistration = () => {
    ctrlRegistry.register('object', async () => {
        const module = await import('./FloatingLabel');
        const FloatingLabel = module.FloatingLabel;
        return {
            customCtrlDef: {
                toString: ({ value, def, defaultValue }) => value?.data || def.data ? '<object>' : defaultValue,
                def: (t, tools) => ({
                    form: [{
                        borderless: true,
                        rows: [
                            [
                                { type: "text", field: "mime", label: t('mimeType'), required: true }
                            ],
                            [
                                { type: "url", field: "data", label: t('data'), required: true }
                            ],
                            [
                                { type: "text", field: "style", label: t('style') }
                            ],
                            ...tools.commonFields(t, { ediatble: false })
                        ]
                    }]
                }),
                control: ({ value, def, placeholder, hideLabel, ...props }) => <FloatingLabel value={value?.data ?? def.data} placeholder={placeholder}><object type={value?.mime ?? def.mime} data={value?.data ?? def.data} style={{ width: '100%', height: '100%', ...def.style }} {...props}>{placeholder}</object></FloatingLabel>
            }
        }
    });
    ctrlRegistry.register('iframe', async () => {
        const module = await import('./FloatingLabel');
        const FloatingLabel = module.FloatingLabel;
        return {
            customCtrlDef: {
                toString: ({ value, def, defaultValue }) => (value || def.data) ? '<iframe>' : defaultValue,
                def: (t, tools) => ({
                    form: [{
                        borderless: true,
                        rows: [
                            [
                                { type: "text", field: "data", label: t('data'), required: true }
                            ],
                            [
                                { type: "text", field: "style", label: t('style') }
                            ],
                            ...tools.commonFields(t, { ediatble: false })
                        ]
                    }]
                }),
                control: ({ value, def, placeholder, hideLabel, ...props }) => <FloatingLabel hideLabel={hideLabel} placeholder={placeholder} value={value?.data ?? def.data}><iframe title={placeholder} src={value?.data ?? def.data} style={{ width: '100%', height: '100%', ...def.style }} {...props}></iframe></FloatingLabel>,
            }
        }
    });
    ctrlRegistry.register('static_image', async () => {
        const module = await import('./ImageInput');
        const ImageInput = module.default;
        return {
            customCtrlDef: {
                toString: () => '<static_image>',
                def: (t, tools) => ({
                    form: [{
                        borderless: true,
                        rows: [
                            ...tools.labelFields(t, { searchable: false }),
                            [
                                { type: "text", field: "text", label: t('text'), required: true }
                            ],
                            [
                                { type: "text", field: "href", label: "href", required: true }
                            ],
                            ...tools.commonFields(t, { ediatble: false })
                        ]
                    }]
                }),
                control: ({ def, placeholder, hideLabel }) => {
                    return <ImageInput placeholder={placeholder} hideLabel={hideLabel} disabled defaultImage={def.uri} />
                }
            }
        }
    })
    ctrlRegistry.register('static_icon', async () => {
        const module = await import('./IconPicker')   ;
        const IconPicker = module.default;
        return {
            customCtrlDef: {
                toString: () => '<static_icon>',
                def: (t, tools) => ({
                    form: [{
                        borderless: true,
                        rows: [
                            ...tools.labelFields(t, { searchable: false }),
                            [
                                { type: "text", field: "literal", label: t('icon'), required: true }
                            ],
                            ...tools.commonFields(t, { ediatble: false })
                        ]
                    }]
                }),
                control: ({ def, ...props }) => {
                    return <IconPicker {...props} value={def.literal} style={def.style} readonly ></IconPicker>
                }
            }
        }
    })
    ctrlRegistry.register('attachment',
        () => import('./Attachment'),
        { supportsEditor: false }
    )
    ctrlRegistry.register('checkbox', () => import('./Checkbox'));
    ctrlRegistry.register('clock', () => import('./Clock'));
    ctrlRegistry.register('colorpicker', () => import('./ColorPicker'));
    ctrlRegistry.register('computed', () => import('./ComputedCtrl'));
    ctrlRegistry.register('entity', () => import('./EntityCtrl'));
    ctrlRegistry.register('entityform', () => import('./EntityForm'));
    ctrlRegistry.register('currency', () => import('./CurrencyInput'));
    ctrlRegistry.register('list',
        () => import('./DataList'),
        { defaultPrintValue: () => EMPTY_ARRAY }
    )
    ctrlRegistry.register('table',
        () => import('./DataTable'),
        { defaultPrintValue: () => EMPTY_ARRAY }
    )
    ctrlRegistry.register('date', () => import('./DateInput'));
    ctrlRegistry.register('dayOfWeekLabel',
        () => import('./DayOfWeekLabel'),
        { supportsEditor: false }
    );
    ctrlRegistry.register('datetime',
        () => import('./DateTimeInput'),
        { supportsEditor: false }
    )
    ctrlRegistry.register('button',
        () => import('./DefaultButton'),
        { supportsEditor: false }
    )
    ctrlRegistry.register('email', () => import('./EmailInput'))
    ctrlRegistry.register('file', () => import('./FileInput'))
    ctrlRegistry.register('icon', () => import('./IconPicker'))
    ctrlRegistry.register('image', () => import('./ImageInput'))
    ctrlRegistry.register('label', () => import('./Label'));
    ctrlRegistry.register('username', async () => {
        const module = await import('./Label');
        const Label = module.default;
        return {
            customCtrlDef: {
                toString: ({ value, defaultValue }) => value ?? defaultValue,
                control: ({ def, href, value, ...props }) => <Label text={value} href={href ?? def.href} {...props}></Label>
            }
        }
    },
    { supportsEditor: false });
    ctrlRegistry.register('datalabel', async () => {
            const module = await import('./Label')
            const Label = module.default;
            return {
                customCtrlDef: {
                    toString: ({ value, defaultValue }) => value ?? defaultValue,
                    def: (t, tools) => {
                        return {
                            form: [{
                                borderless: true,
                                rows: [
                                    ...tools.labelFields(t),
                                    ...tools.fieldFields(t),
                                    [{ type: "table", field: "styles", label: t('conditionalStyling'), "columns": [
                                        { type: "option", field: "operator", title: t('operator'), options: ["<", "<=", ">", ">=", "==", "!="], editable: true, required: true },
                                        { type: "text", field: "value", title: t('value'), editable: true, required: true },
                                        { type: "colorpicker", field: "style.color", title: t('color'), editable: true, required: true },
                                        { type: "colorpicker", field: "style.backgroundColor", title: t('backgroundColor'), editable: true, required: true },
                                        { type: "number", field: "style.fontSize", title: t('fontSize'), editable: true, required: true },
                                        { type: "checkbox", field: "style.bold", title: t('bold'), editable: true },
                                        { type: "checkbox", field: "style.italic", title: t('italic'), editable: true }
                                    ]}],
                                    ...tools.commonFields(t)
                                ]
                            }]
                        }
                    },
                    control: ({ def, value, hideLabel, href, ...props }) => {
                        let style;
                        if (def.styles) {
                            style = { ...def.styles.find(s => {
                                switch (s.operator) {
                                    case '<':
                                        return s.value < value;
                                    case '>':
                                        return s.value > value;
                                    case '<=':
                                        return s.value <= value;
                                    case '>=':
                                        return s.value >= value;
                                    case '==':
                                        return s.value == value;
                                    case '!=':
                                        return s.value != value;
                                    default:
                                        return false;
                                }
                            })?.style };
                            if (style?.fontSize) {
                                style.fontSize += 'pt';
                            }
                            if (style.bold) {
                                style.fontWeight = 'bold';
                                delete style.bold;
                            }
                            if (style.italic) {
                                style.fontStyle = 'italic';
                                delete style.italic;
                            }
                        }
                        return <Label hideLabel={hideLabel} text={value} style={{ ...props.style, ...style }} href={href ?? def.href} {...props}></Label>;
                    }
                }
            }
        },
        { supportsEditor: false }
    )
    ctrlRegistry.register('language', () => import('./LanguageInput'));
    ctrlRegistry.register('number', () => import('./NumericInput'));
    ctrlRegistry.register('phone', () => import('./PhoneInput'));
    ctrlRegistry.register('range', () => import('./Range'));
    ctrlRegistry.register('richtext', () => import('./RichTextEditor'));
    ctrlRegistry.register('option', () => import('./Select'));
    ctrlRegistry.register('labelled_option', async () => {
            const module = await import('./Select');
            const Select = module.default;
            return {
                customCtrlDef: {
                    toString: ({ value, defaultValue, def }) => {
                        if (value === null || value === undefined) return defaultValue;
                        let options = def.options;
                        validateOptions(options, 'label', 'value');
                        return options.find(o => o.value === value)?.label ?? value;
                    },
                    control: ({ value, def, args, ...props }) => {
                        let options = def.options;
                        if (typeof options === 'string') {
                            options = safeEval(options)(value, args);
                        }
                        validateOptions(options, 'label', 'value');
                        return <Select value={value} wildcard={def.wildcard} {...props} options={def.options} labelField='label' valueField='value'></Select>
                    }
                }
            };
        },
        { supportsEditor: false }
    );
    ctrlRegistry.register('signature', () => import('./Signature'));
    ctrlRegistry.register('tag',
        () => import('./TagManager'),
        { defaultPrintValue: () => EMPTY_ARRAY }
    )
    ctrlRegistry.register('textarea', () => import('./TextareaInput'));
    ctrlRegistry.register('json', async () => {
        const module = await import('./TextareaInput');
        const TextareaInput = module.default;
        return {
            customCtrlDef: {
                toString: ({ value, defaultValue }) => value ? JSON.stringify(value, null, 2) : defaultValue,
                def: (t, tools) => ({
                    form: [{
                        borderless: true,
                        rows: [
                            ...tools.labelFields(t),
                            ...tools.fieldFields(t),
                            ...tools.commonFields(t)
                        ]
                    }]
                }),
                control: ({ value, def, href, style, live, ...props }) => <TextareaInput live={false} value={JSON.stringify(value, null, 2)} rows={def.rowspan} maxLength={def.maxlength} href={href ?? def.href} style={{ resize: def?.resize ?? 'none', ...style }} {...props}></TextareaInput>
            } 
        }
    })
    ctrlRegistry.register('text', () => import('./TextInput'));
    ctrlRegistry.register('time', () => import('./TimeInput'));
    ctrlRegistry.register('timezone', () => import('./TimezoneInput'));
    ctrlRegistry.register('typeahead',
        () => import('./TypeaheadInput')
    );
    ctrlRegistry.register('url', () => import('./UrlInput'));
    ctrlRegistry.register('hidden', () => Promise.resolve({
            customCtrlDef: {
                control: () => null, 
                toString: () => null
            }
        }),
        { defaultPrintValue: () => '', supportsEditor: false }
    );
    ctrlRegistry.register('address', () => import('./AddressInput'),
        { supportsEditor: false, defaultPrintValue: () => ({}) }
    )
    ctrlRegistry.register('gender', () => import('./GenderDropdown'));
    ctrlRegistry.register('diagram',
        () => import('./Diagram'),
        { supportsEditor: false }
    )
    ctrlRegistry.register('rag', () => import('./RAGDropdown'));
    ctrlRegistry.register('unavailable', () => import('./UnavailableComponent'),
        (UnavailableComponent, { def, ...props }) => <UnavailableComponent { ...props }></UnavailableComponent>
    )
    ctrlRegistry.register('matrix', () => import('./Matrix'));
    ctrlRegistry.register('link', () => import('./HyperLink'));
    ctrlRegistry.register('pdf', () => import('./EmbeddedPDF'));
    ctrlRegistry.register('qrcode', () => import('./QRCode'));
    ctrlRegistry.register('static_qrcode', async () => {
        const module = await import('./QRCode')   ;
        const QRCode = module.default;
        return {
            customCtrlDef: {
                toString: () => '<static_qrcode>',
                def: (t, tools) => ({
                    form: {
                        borderless: true,
                        rows: [
                            ...tools.labelFields(t, { searchable: false }),
                            [
                                { type: "option", field: "level", label: t('qrcodeLevel'), options: ["L","M","Q","H"] },
                                { type: "number", field: "size", label: t('size'), min: 0, max: 1024 }
                            ],
                            [
                                { type: "text", field: "code", label: t('value'), required: true }
                            ],
                            ...tools.commonFields(t, { ediatble: false })
                        ]
                    }
                }),
                control: ({ def, ...props }) => {
                    return <QRCode {...props} value={def.code} level={def.level} size={def.size}></QRCode>
                }
            }
        }
    });
}